import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { Animal, FamilyTreeNode } from "@project/types/vrindavan-gaushala";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/animals`;
const SILENT: RequestConfig = { showNotification: false };

class AnimalService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<Animal>> => {
    return fetchListPage<Animal>(`${BASE}/`, query);
  };

  get = async (id: number): Promise<Animal | undefined> => {
    const data = await get<ApiItemResponse<Animal> | Animal>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (
    payload: Record<string, unknown>
  ): Promise<Animal | undefined> => {
    const cleaned = { ...payload };
    if ("mother" in cleaned) {
      cleaned.mother = cleaned.mother === 0 || cleaned.mother === "0" || cleaned.mother === "" || cleaned.mother === "null" || cleaned.mother === null || cleaned.mother === undefined ? null : Number(cleaned.mother);
    }
    if ("father" in cleaned) {
      cleaned.father = cleaned.father === 0 || cleaned.father === "0" || cleaned.father === "" || cleaned.father === "null" || cleaned.father === null || cleaned.father === undefined ? null : Number(cleaned.father);
    }
    const data = await post<
      ApiItemResponse<Animal> | Animal,
      Record<string, unknown>
    >(`${BASE}/`, cleaned, SILENT);
    return unwrapItem(data);
  };

  update = async (
    id: number,
    payload: Record<string, unknown>
  ): Promise<Animal | undefined> => {
    const cleaned = { ...payload };
    if ("mother" in cleaned) {
      cleaned.mother = cleaned.mother === 0 || cleaned.mother === "0" || cleaned.mother === "" || cleaned.mother === "null" || cleaned.mother === null || cleaned.mother === undefined ? null : Number(cleaned.mother);
    }
    if ("father" in cleaned) {
      cleaned.father = cleaned.father === 0 || cleaned.father === "0" || cleaned.father === "" || cleaned.father === "null" || cleaned.father === null || cleaned.father === undefined ? null : Number(cleaned.father);
    }
    const data = await patch<
      ApiItemResponse<Animal> | Animal,
      Record<string, unknown>
    >(`${BASE}/${id}/`, cleaned, SILENT);
    return unwrapItem(data);
  };



  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };

  getFamilyTree = async (id: number): Promise<FamilyTreeNode | undefined> => {
    const data = await get<ApiItemResponse<FamilyTreeNode> | FamilyTreeNode>(
      `${BASE}/${id}/family-tree/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };
}

export const animalService = new AnimalService();
